import { motion } from "framer-motion";
import { useLang } from "@/i18n";

export default function AboutSection() {
  const { str } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative px-6 sm:px-10 lg:px-16 py-24 lg:py-32 border-b border-white/10"
    >
      <p className="font-ticker text-[11px] tracking-[0.4em] uppercase text-[#25D366] mb-4">
        {str.aboutTag}
      </p>
      <h2 className="font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-none mb-20 lg:mb-28">
        {str.aboutHeading1} <span className="text-[#25D366]">{str.aboutHeading2}</span>
      </h2>

      <div>
        {str.chapters.map((c) => (
          <motion.div
            key={c.n}
            data-testid={`chapter-${c.n}`}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="relative border-t border-white/10 py-16 lg:py-24 overflow-hidden"
          >
            <span
              aria-hidden
              className="pointer-events-none select-none absolute -top-6 right-0 font-display font-black text-[26vw] lg:text-[15vw] leading-none text-white/[0.04]"
            >
              {c.n}
            </span>
            <div className="relative z-10 max-w-2xl">
              <span className="font-ticker text-xs tracking-[0.4em] text-[#25D366]">{c.n} /</span>
              <h3 className="mt-4 font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl">
                {c.title}
              </h3>
              <p className="mt-5 text-sm sm:text-base leading-relaxed text-white/55">{c.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
